import React from "react";

function statusLabel(status) {
  if (status === "retains") return "зберігає місце";
  if (status === "loses") return "втрачає місце";
  return "—";
}

// КРОК 4: окремий блок "Розбіжності з чинною процедурою" -- студенти, у
// яких статус за сумою балів і за моделлю відрізняється.
const ImportDiscrepanciesBlock = ({ rows, anonymize = false }) => {
  return (
    <div className="input-component" data-testid="discrepancies-block">
      <h3 className="text-header">Розбіжності з чинною процедурою</h3>
      {rows.length === 0 ? (
        <p className="text-header">Розбіжностей між рангом за сумою і моделлю немає.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th className="table-header">ПІБ</th>
              {!anonymize && <th className="table-header">Кімната</th>}
              <th className="table-header">Статус за сумою</th>
              <th className="table-header">Статус за моделлю</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className="table-content">{row.pib || `#${row.id}`}</td>
                {!anonymize && <td className="table-content">{row.room ?? "—"}</td>}
                <td className="table-content">{statusLabel(row.sumStatus)}</td>
                <td className="table-content">{statusLabel(row.modelStatus)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ImportDiscrepanciesBlock;
